import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import _, { uniqueId } from 'lodash';

const allowedKeys = [32, 188, 186];

class TagInput extends Component {
  constructor(props) {
    super(props);

    this.state = {
      items: [],
      input: '',
    };
  }

  componentDidMount() {
    const { value } = this.props;
    if (!_.isEmpty(value)) {
      this.setState({
        items: [...value],
      });
    }
  }

  componentWillReceiveProps(nextProps) {
    const { value } = this.props;
    if (value.length !== nextProps.value.length) {
      this.setState({
        items: [...nextProps.value],
      });
    }
  }

  handleInputChange = (e) => {
    const { value } = e.target;
    this.setState({ input: value });
  };

  handleInputKeyDown = (e) => {
    const { onChange = () => {}, maxTagsAllowed, disableSubmit } = this.props;
    const { items, input } = this.state;

    if ((allowedKeys.includes(e.keyCode) || e.keyCode === 13) && items.length <= maxTagsAllowed) {
      if (allowedKeys.includes(e.keyCode) || disableSubmit) {
        e.preventDefault();
      }
      const { value } = e.target;

      if (value.length && !items.includes(value)) {
        this.setState((state) => ({
          items: [...state.items, value],
          input: '',
        }));
        onChange([...items, value]);
      }
    }

    if (items.length && e.keyCode === 8 && !input.length) {
      this.setState((state) => ({
        items: state.items.slice(0, state.items.length - 1),
      }));
      onChange(items.slice(0, items.length - 1));
    }
  };

  handleRemoveItem = (index) => {
    return () => {
      const { onChange = () => {} } = this.props;
      const { items } = this.state;
      const remainingItems = items.filter((item, i) => i !== index);

      this.setState({
        items: remainingItems,
      });
      onChange(items.filter((item, i) => i !== index));
    };
  };

  handlePaste = (e) => {
    const { onChange = () => {}, maxTagsAllowed } = this.props;
    const { items } = this.state;
    const clipboardData = e.clipboardData || e.originalEvent.clipboardData || window.clipboardData;
    const pastedData = clipboardData.getData('text');

    if (pastedData.length) {
      e.preventDefault();
      const splitValue = pastedData.trim().split(/[ ;,]+/);
      const uniqueValues = splitValue.filter((item) => !items.includes(item));

      if (uniqueValues.length <= maxTagsAllowed) {
        this.setState((state) => ({
          items: [...state.items, ...uniqueValues],
          input: '',
        }));
        onChange([...items, ...uniqueValues]);
      }
    }
  };

  handleOnBlur = (e) => {
    const { onBlur = () => {}, onChange = () => {} } = this.props;
    const { items } = this.state;
    const { value } = e.target;
    onBlur(e);

    if (value.length && !items.includes(value)) {
      this.setState((state) => ({
        items: [...state.items, value],
        input: '',
      }));
      onChange([...items, value]);
    }
  };

  render() {
    const { name, placeholder, className, readonly } = this.props;
    const { items, input } = this.state;
    const classes = classNames('tag-input', [className]);

    return (
      <div className={classes} id={`${name}-div-input`}>
        {items.map((item, i) => (
          <div className="tag" key={uniqueId()}>
            <div>{item}</div>
            <div className="buttons">
              <button type="button" className="close" aria-label="Close" onClick={this.handleRemoveItem(i)}>
                <FontAwesomeIcon icon={{ prefix: 'fal', iconName: 'times' }} size="xs" />
              </button>
            </div>
          </div>
        ))}
        <input
          id={`${name}-input`}
          name={name}
          value={input}
          onChange={this.handleInputChange}
          onBlur={this.handleOnBlur}
          onKeyDown={this.handleInputKeyDown}
          onPaste={this.handlePaste}
          placeholder={!items.length ? placeholder : ''}
          autoCapitalize="none"
          autoComplete="nope"
          autoCorrect="off"
          readOnly={readonly}
        />
      </div>
    );
  }
}
TagInput.defaultProps = {
  maxTagsAllowed: 15,
};

TagInput.propTypes = {
  name: PropTypes.string,
  className: PropTypes.string,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  placeholder: PropTypes.string,
  maxTagsAllowed: PropTypes.number,
  disableSubmit: PropTypes.bool,
};

export default TagInput;
